<div [attr.data-cy]="baseDataCy">
  <div data-cy="entity-element" ngClass="{{globalEntityElementClass}}">
    @if (element != null) {
      <div
        [ngClass]="{'selected': selected, 'is-entity-new-element': isNewEntityElement, 'inactive': hasInactiveBorder, 'connected-with-parent': isConnectedWithParent}"
        class="entity-element-container"
        data-cy="entity-element-container">
        <div class="entity-element-line">
          <div (click)="closeContextMenus()"
            [attr.data-cy]='nameDataCy'
            class="entity-element-name text-ellipsis">
            <!--
            Disabling dynamic tooltip on elements without display code, for the warnings to function properly.
            "display: -webkit-box" forces the span to be a block element and the "white-space: initial" removes the
            line breaking behaviour, which in turn disables the NgbTooltip dynamic behaviour, since the dynamic tooltip
            is only triggered when the child element width is bigger than the parents.
            -->
            <app-tooltip [dynamic]="hasDisplayCode()" [message]="element.name">
              <span [ngClass]="{'entity-element-not-display-code' : !hasDisplayCode()}"
              data-cy="entity-element-name">{{element.name}}</span>
            </app-tooltip>
          </div>
          @if (hasContextMenu) {
            <app-context-menu [contextMenuModel]="contextMenu"></app-context-menu>
          } @else {
            <div class="entity-element-remove-button">
              @if (hasRemoveAction) {
                <app-tooltip [dynamic]="false" message="Remove">
                  <span (click)="removeClick()" [class]="elementActionButtonClass" data-cy="entity-element-action"></span>
                </app-tooltip>
              }
            </div>
          }
        </div>
        <div (click)="closeContextMenus()"
          [ngClass]="{'no-code-elements-second-line': !hasDisplayCode()}"
          class="entity-element-line">
          <div [attr.data-cy]="codeDataCy"
            class="entity-element-code text-ellipsis">
            <app-tooltip [message]="element.displayCode">
              <span data-cy="entity-element-code">{{element.displayCode}}</span>
            </app-tooltip>
          </div>
          @if (isParentCodeVisible) {
            <div [attr.data-cy]="parentCodeDataCy"
            class="entity-element-detail">{{element.displayParentCode}}</div>
          } @else {
            <div [attr.data-cy]="detailDataCy" class="entity-element-detail">{{element.detail}}</div>
          }
          @if (hasIcon()) {
            <div [class]="getIconClass()" data-cy="entity-element-icon"></div>
          }
          @if (!element.active) {
            <div
              class="entity-element-inactive-marker"
              data-cy="entity-element-inactive-marker-container">
              <app-tooltip [dynamic]="false" message="Inactive">
                <span class="inactive-marker"
                data-cy="entity-element-inactive-marker"></span>
              </app-tooltip>
            </div>
          }
        </div>
      </div>
    }
    @if (hasUnfinishedPathMarker) {
      <div
        class="unfinished-marker-container"
        data-cy="entity-element-unfinished-path-marker">
        <app-tooltip [dynamic]="false" message="Unfinished path origin">
          <span class="unfinished-marker"></span>
        </app-tooltip>
      </div>
    }
    @if (hasInlineWarnings) {
      <app-warning-inline [warningInlineLabelsArray]="warnings.labels"
      [warningType]="warnings.severity"></app-warning-inline>
    }

  </div>
</div>

<!-- Template for detail (blue text section) that is not related with displayParentCode-->

<!-- Template for the action button icon that is not the context menu -->
